<template>
    <div id="products-list">
        <b-overlay :show="showLoading" spinner-variant="primary">

            <b-card>
                <b-row>
                    <b-col cols="8">
                        <b-form-input @input="updateSearchQuery" v-model="searchQuery"  size="sm" placeholder="Recherche" type="text"
                            class="d-inline-block" />
                    </b-col>
                </b-row>
                <!-- <hr> -->
                <ag-grid :agGrid="agGrid" ref="agGrid" @cellDoubleClicked="cellDoubleClicked" :showHeader="false" />

            </b-card>
        </b-overlay>
    </div>
</template>

<script>

import AgGrid from "@/views/components/ag-grid/AgGrid.vue"
import { formatPrice } from "@/utils/formatting";

export default {
    components: {
        AgGrid,
    },
    data() {
        return {
            searchQuery: "",
            showLoading: true,
            agGrid: {
                columnDefs: [
                    {
                        headerName: "Description",
                        field: "Description",
                    },
                    {
                        headerName: "Type",
                        field: "Gen_Prod_Posting_Group",
                    },
                    {
                        headerName: "Fournisseur",
                        field: "Vendor_Name",
                    },
                    {
                        headerName: "Prix H.T",
                        field: "Unit_Price",
                        valueGetter: function (tr) {
                            return formatPrice(tr.data.Unit_Price);
                        },
                    },
                    {
                        headerName: "Prix Public",
                        field: "Public_Price",
                        valueGetter: function (tr) {
                            return formatPrice(tr.data.Public_Price);
                        },
                    },
                    {
                        headerName: "Quota",
                        field: 'Open_Quantity',
                    },
                ],
                rows: []
            },
        }
    },
    async created() {
        const response = await this.$http.get("distribution");
        // console.log(response);
        this.agGrid.rows = response.data;
        this.showLoading = false;
    },
    methods: {
        updateSearchQuery(val) {
            const gridApi = this.$refs.agGrid.gridApi;
            gridApi.setQuickFilter(val);
        },
        cellDoubleClicked(param) {
            this.$emit('itemClicked', param);
        }
    }
}
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
    .card {
        background-color: initial;
        box-shadow: initial;
    }

    .card-body {
        padding: 0px;
    }
}
</style>